import React, { createContext, useContext } from 'react';

const ModalContext = createContext<{
	isInModal: boolean;
}>({
	isInModal: false,
});

export const ModalProvider = ({ children }: { children: React.ReactNode }) => {
	return <ModalContext.Provider value={{ isInModal: true }}>{children}</ModalContext.Provider>;
};

export const useIsInModal = () => {
	const context = useContext(ModalContext);
	if (!context) {
		throw new Error('useIsInModal must be used within a ModalProvider');
	}
	return context;
};
